import "./admin.css";

function Dashboard() {

return (

<div className="dashboard-page">

<div className="stats-grid">

<div className="stat-card">

<h4>Total Projects</h4>

<h2>124</h2>

</div>

<div className="stat-card">

<h4>Pending PMs</h4>

<h2>12</h2>

</div>

<div className="stat-card">

<h4>Messages Sent</h4>

<h2>1.2M</h2>

</div>

<div className="stat-card">

<h4>Failed Logs</h4>

<h2>93</h2>

</div>

</div>

<div className="table-card">

<h3>Recent Activity</h3>

</div>

</div>

)

}

export default Dashboard;